export default "__VITE_ASSET__BGKSJu3P__"